import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import ImagemIniciarAtendimento from 'assets/img/atendente.svg';
import CardStatus from 'components/CardPorcentagemRequerimento';
import Button from 'components/Button';
import { ENUM_TIPO_PERFIL } from 'utils/permissao';
import { fetchIniciarAtendimento, fetchGetAtendenteByDocumento } from 'store/fetchActions/fetchAtendente';
import { fetchBuscarCardAtendente } from 'store/fetchActions/fetchFormulario';
import { fetchNotificationApp } from 'store/fetchActions/fetchApp';
import { privateRoot, requerimentos } from 'routes/paths';
import {
  getMensagemDia,
  buscarListaReatendimento,
  descricaoAtendente,
  descricaoIniciarAtendimento,
  montarArrayCard,
  getDescricaoCard,
} from './HomeAtendente';
import * as S from './styles';
import { altImageAtendimento } from 'utils/acessibilidade';

export default function HomeAtendente() {
  const history = useHistory();
  const dispatch = useDispatch();

  const user = useSelector(state => state.sefaz.userProfile);
  const dadosCard = useSelector(state => state.formulario.dadosCardAtendente);
  const modalState = useSelector(state => state.app.modal);
  const atendenteLogado = useSelector(state => state.atendente.atendenteLogado);
  const unitaryTests = useSelector(state => state.app.unitaryTests);

  const [loadingButton, setLoadingButton] = useState(true);

  React.useEffect(() => {
    if (unitaryTests) return;
    if (user) {
      if (user?.profile !== ENUM_TIPO_PERFIL.ATENDENTE) {
        history.push(privateRoot);
      }
      dispatch(fetchGetAtendenteByDocumento(user?.cpf_cnpj)).then(atendente => {
        setLoadingButton(false);
        dispatch(buscarListaReatendimento(modalState, atendente?.id));
        dispatch(fetchBuscarCardAtendente(atendente?.id));
      });
    }

    // eslint-disable-next-line
  }, [dispatch, history, user]);

  const iniciarAtendimento = () => {
    setLoadingButton(true);
    dispatch(fetchIniciarAtendimento(atendenteLogado?.id))
      .then(formularioResumo => {
        if (formularioResumo?.localizador) {
          fetchNotificationApp('Novo Atendimento Disponível');
          history.push(requerimentos);
        } else {
          fetchNotificationApp('Nenhum Atendimento Disponível');
        }
      })
      .finally(() => setLoadingButton(false));
  };

  return (
    <S.Page>
      <S.Titulo>ATENDENTE {atendenteLogado?.isSetorial && ' SETORIAL'}</S.Titulo>
      <S.Subtitulo>
        {getMensagemDia()} {user?.given_name?.split(' ')[0]}
      </S.Subtitulo>
      <S.Descricao>{descricaoAtendente(user?.given_name)}</S.Descricao>
      <S.Descricao fontWeight={'500'}>{descricaoIniciarAtendimento}</S.Descricao>
      <Button
        text={'Iniciar Atendimento'}
        clickAction={() => iniciarAtendimento()}
        css={{ display: 'block' }}
        disabled={
          user?.profile !== ENUM_TIPO_PERFIL.ATENDENTE || atendenteLogado?.emAtendimento || dadosCard?.ABERTO === 0
        }
        loading={loadingButton}
      />

      {montarArrayCard(dadosCard, atendenteLogado?.isSetorial).map(item => {
        return (
          <CardStatus
            key={item.id}
            cor={item.cor}
            titulo={item.descricao}
            valor={item.valor}
            porcentagem={item?.porcentagem}
            descricao={getDescricaoCard(item.valor, atendenteLogado?.isSetorial)}
          />
        );
      })}

      <S.Imagem src={ImagemIniciarAtendimento} alt={altImageAtendimento} />
    </S.Page>
  );
}
